import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ListarDocumentosFiscaisEmitidosRequest } from '../../requests/repo-dfe/listar-documentos-fiscais-emitidos.request';
import { ListarDocumentosFiscaisEmitidosResponse } from '../../responses/repo-dfe/listar-documentos-fiscais-emitidos.response';
import { DetalheNFeEmitidoResponse } from '../../responses/repo-dfe/detalhe-nfe-emitido.response';
import { DetalheNFCeEmitidoResponse } from '../../responses/repo-dfe/detalhe-nfce-emitido.response';
import { DetalheNFSeEmitidoResponse } from '../../responses/repo-dfe/detalhe-nfse-emitido.response';
import { OrigemDocumentoFiscalEmitidoEnum } from '../../../enums/repo-dfe/origem-documento-fiscal-emitido.enum';
import { DownloadDocumentosFiscaisEmitidosRequest } from '../../requests/repo-dfe/download-documentos-fiscais-emitidos.request';
import { DownloadDocumentosFiscaisEmitidosResponse } from '../../responses/repo-dfe/download-documentos-fiscais-emitidos.response';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PainelContadorService extends CommonService {
  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  // A URL base para o controller PainelContador.
  // Certifique-se de que a variável 'urlApiRepoDFe' existe no seu arquivo environment.ts
  private readonly apiUrl = `${environment.urlApiRepoDFe}painelcontador`;

  /** Lista os documentos fiscais emitidos do painel do contador. */
  public listarDocumentosFiscaisEmitidos(filter: ListarDocumentosFiscaisEmitidosRequest, paginaAtual: number = 0): Observable<ListarDocumentosFiscaisEmitidosResponse> {
    const url = `${this.apiUrl}/getAll`;
    let params = new HttpParams().set('paginaAtual', paginaAtual.toString());

    return this.httpClient
      .post<ListarDocumentosFiscaisEmitidosResponse>(url, filter, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public obterNFeEmitido(idNFeEmitido: number, origemDocumentoFiscalEmitido: OrigemDocumentoFiscalEmitidoEnum): Observable<DetalheNFeEmitidoResponse> {
    const url = `${this.apiUrl}/nfe/idNFeEmitido/${idNFeEmitido}`;
    const params = new HttpParams().set('origemDocumentoFiscalEmitido', origemDocumentoFiscalEmitido.toString());
    return this.httpClient
      .get<DetalheNFeEmitidoResponse>(url, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public obterNFCeEmitido(idNFCeEmitido: number, origemDocumentoFiscalEmitido: OrigemDocumentoFiscalEmitidoEnum): Observable<DetalheNFCeEmitidoResponse> {
    const url = `${this.apiUrl}/nfce/idNFCeEmitido/${idNFCeEmitido}`;
    const params = new HttpParams().set('origemDocumentoFiscalEmitido', origemDocumentoFiscalEmitido.toString());
    return this.httpClient
      .get<DetalheNFCeEmitidoResponse>(url, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public obterNFSeEmitido(idNFSeEmitido: number, origemDocumentoFiscalEmitido: OrigemDocumentoFiscalEmitidoEnum): Observable<DetalheNFSeEmitidoResponse> {
    const url = `${this.apiUrl}/nfse/idNFSeEmitido/${idNFSeEmitido}`;
    const params = new HttpParams().set('origemDocumentoFiscalEmitido', origemDocumentoFiscalEmitido.toString());
    return this.httpClient
      .get<DetalheNFSeEmitidoResponse>(url, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  /** Solicita o download dos documentos fiscais emitidos identificados no request. */
  public downloadDocumentosFiscaisEmitidos(request: DownloadDocumentosFiscaisEmitidosRequest): Observable<DownloadDocumentosFiscaisEmitidosResponse> {
    const url = `${this.apiUrl}/download`;

    return this.httpClient
      .post<DownloadDocumentosFiscaisEmitidosResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
